<template>
    <div>
        <form id="form-element-evidences" v-on:submit.prevent="validateBeforeSubmitEvidences">
            <div v-if="showEvidencesComp">
                <h5>{{ $t('textProcesses.textTitleEvidence') }}</h5>
                <div class="form-group">
                    <hr>
                </div>
                <ejs-grid ref='grid'
                          :dataSource='gridDataComplianceEvidences'
                          :allowPaging="true"
                          :allowSorting="true"
                          :pageSettings='pageSettings'
                          :allowTextWrap='true'
                          :textWrapSettings="wrapSettings">
                    <e-columns>
                        <e-column field="responsable" :headerText="$t('gridHeaderText.user')" width="2"
                                  textAlign="center" :template="templateResponsable"></e-column>
                        <e-column :template="date_created" :headerText="$t('gridHeaderText.date')" width="2"
                                  textAlign="left"></e-column>
                        <e-column :headerText="'Evidencia'" textAlign="left" width="5"
                                  :template="templateComplianceSupport"></e-column>
                        <e-column v-if="!data.readOnly" :headerText="'Borrar'" textAlign="left" width="7"
                                  :template="templateComplianceEvidence"></e-column>
                    </e-columns>
                </ejs-grid>
                <div v-if="addEvidences">
                    <div class="form-group">
                        <hr>
                    </div>
                    <h5>Nueva Evidencia</h5>
                    <div class="form-group">
                            <label for="uploadFilesEvidence">Enlace externo</label>
                            <ejs-textbox name="external_link" data-msg-containerid="nameError3" v-model="formDataEvidences.external_link"
                                        placeholder="Link Externo"></ejs-textbox>
                        <div id="nameError3"></div>
                    </div>
                    <div class="form-group">
                            <label for="uploadFilesEvidence">Archivo</label>
                            <ejs-uploader ref="uploadObj" name="uploadFiles" id="uploadFilesEvidence" :multiple='true'
                                        :asyncSettings="uploaderSettings" :uploading="addHeaders" :removing="beforeDeleteFile"
                                        :success="beforeUploadFiles" :maxFileSize="maxFileSize"></ejs-uploader>
                    </div>
                    <div class="form-group">
                        <ejs-button type='submit' cssClass="e-primary mt-3" :disabled="isSubmittingEvidences">
                            {{ isSubmittingEvidences ? 'Guardando...' : 'Guardar evidencias' }}
                        </ejs-button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import axios from 'axios'
import {DatePickerPlugin} from '@syncfusion/ej2-vue-calendars'

Vue.use(DatePickerPlugin)
export default {
    name: "processes-detail-compliance-evidence-edit",
    props: ["data","showEvidences"],
    data: function () {
        return {
            maxFileSize: 20 * 1024 * 1024,
            validStatus: '',
            validIsAdmin: 0,
            toggleFormsBasicData: true,
            toggleFormsEvidences: true,
            toggleFormsObservations: false,
            formObj: '',
            extensions: '.eml, .msg, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .pst, .ost, .jpg, .png, .jpeg, .rar, .zip, .pdf',
            btnEditstatus: false,
            rolLocal: "",
            listStatus: ['Incumplido', 'Cumplido', 'No Aplica', 'Pendiente', 'Vencido'],
            listRelevances: ['Baja', 'Media', 'Alta', 'No Aplica'],
            formDataEvidences: {
                statusComplianceId: null,
                external_link: '',
                pathFile: [],
            },
            formObjEvidences: '',
            formObjObservations: '',
            formDataObservations: {
                statusComplianceId: 0,
                observations_date: '',
                observations_text: '',
                pathFile: ''
            },
            options: {
                rules: {
                    'external_link': {
                        url: [true, "* Campo link externo no valido."]
                    },
                }
            },
            optionsObservations: {
                rules: {
                    'observations_text': {
                        required: [true, "* Campo observación requerido."]
                    },
                    'observations_date': {
                        required: [true, "* Campo fecha requerido."],
                        date: [true, "* Campo fecha no valido."]
                    },
                }
            },
            uploaderSettings: {
                saveUrl: process.env.BASE_URL_FILE_SAVE,
                removeUrl: process.env.BASE_URL_FILE_REMOVE
            },
            templateResponsable: function (e) {
                return {
                    template: Vue.component('componentResponsable', {
                        template: `
                            <ejs-tooltip :content="data.responsable" ref="tooltip" :position="'TopCenter'">
                            <div class="e-avatar e-avatar-small e-avatar-circle">{{ $getInitials(data.responsable) }}
                            </div>
                            </ejs-tooltip>`,
                        data() {
                            return {
                                data: {},
                            };
                        },
                    })
                }
            },
            templateComplianceEvidence: function (e){
                return {
                     template: Vue.component('componentDeleteEvidence', {
                         template: `
                             <span class="e-icons e-delete-1" @click="deleteEvidence(data)"></span>
                         `,
                         data() {
                            return {
                                data: {},
                            };
                        },
                         methods: {
                             deleteEvidence: function(data){
                                 console.log(data)
                                  axios.delete('/auth/compliance/deleteComplianceEvidences/'+data.id).then(response => {
                                    this.$store.dispatch('moduleProcesses/actionsProcessesDetail', response.data.proceso_id).then(response => {});
                                    Vue.prototype.$eventHub.$emit('showToastNotification', response.data);
                                });
                             }
                         },
                     })
                }
            },
            templateComplianceSupport: function (e) {
                return {
                    template: Vue.component('componentComplianceSupport', {
                        template: `
                            <div v-html="viewLinksSupport(data)"></div>`,
                        data() {
                            return {
                                data: {},
                            };
                        },
                        methods: {
                            viewLinksSupport: function (data) {
                                let response = "";
                                if (data.type == 'file') {
                                    let splitImage = data.evidence.split(/[\\$]/).pop(),
                                        extArr = data.evidence.split('.'),
                                        ext = extArr[extArr.length - 1].toLowerCase(),
                                        show = true,
                                        classDoc = '';
                                    if (ext === 'pdf')
                                        classDoc = "e-pdf-icon";
                                    else if (ext === 'jpg' || ext === 'png' || ext === 'jpeg' || ext === 'bmp')
                                        classDoc = "e-image-icon";
                                    else
                                        show = false;
                                    if (show) response += "<a class='mx-1 " + classDoc + "'href='" + process.env.BASE_URL_API_BACK + "viewFile/" + splitImage + "' target='_blank'></a>";
                                    response += "<a class='mx-1 e-download-icon' href='" + process.env.BASE_URL_API_BACK + "downloadFile/" + extArr[0] + "/" + extArr[1] + "' target='_self' download></a>";
                                    response += "<div style='overflow: hidden; text-overflow: ellipsis;white-space:nowrap;'>"+ extArr[0].split('/')[1] +"</div>"
                                }
                                if(data.type == 'link'){
                                    response += "<a class='mx-1' href='" + data.evidence + "' target='_blank'><span class='e-icons e-hyperlink-open'></span></a>";
                                }
                                if (response === "") {
                                    response += "-";
                                }
                                return response;
                            }
                        }
                    })
                }
            },
            date_created: function (e) {
                return {
                    template: Vue.component('templateButtons', {
                        template: `<span>{{ data.created_at }}</span>`,
                        data() {
                            return {
                                data: {}
                            };
                        },
                        methods: {
                            formatDate: function (date) {
                                let dateTmp = new Date(date);
                                //Fecha UTC -> Fecha Local
                                let event = new Date(Date.UTC(dateTmp.getFullYear(), dateTmp.getMonth(), dateTmp.getDate(), dateTmp.getHours(), dateTmp.getMinutes(), 0, 0));
                                var options = {year: "numeric", month: "numeric", day: "numeric"};
                                return event.toLocaleString("es-ES", options) + ' ' + event.toLocaleTimeString();
                            }
                        },
                    })
                }
            },
            gridDataComplianceEvidences: [],
            pageSettings: {pageSize: 25},
            wrapSettings: {wrapMode: 'Content'},
            responsableFlag: false,
            isSubmittingEvidences: false
        }
    },
    mounted: function () {
        this.formObjEvidences = new FormValidator('#form-element-evidences', this.options);

        /**Validación si la persona logeada es responsable del cumplimiento */
            //let localStor = JSON.parse(localStorage.access_avatar);
        let localStor = this.$store.getters["moduleAvatar/avatar"];
        for (let index = 0; index < this.data.responsable.length; index++) {
            if (this.data.responsable[index].user_name === localStor.name) {
                this.responsableFlag = true;
            }
        }

        /** Obtiene el Rol */
        this.rolLocal = localStor.role;
    },
    computed: {
        processesDetail() {
            return this.$store.state.moduleProcesses.dataProcessesDetail;
        },
        showEvidencesComp(){
            return (this.showEvidences !== undefined)? this.showEvidences : true
        },
        addEvidences(){
            return (this.data.readOnly !== undefined)? !this.data.readOnly : true
        }
    },
    watch: {
        processesDetail(newValue,oldValue){
            this.updateEvidences()
        }
    },
    methods: {
        addHeaders: function (args) {
            args.currentRequest.setRequestHeader('Authorization', `Bearer ${this.$store.state.moduleSession.token}`);
        },
        beforeDeleteFile: function(args){
            // 
        },
        beforeUploadFiles: function (args) {
            if(args.operation == 'remove'){
                this.formDataEvidences.pathFile =  this.formDataEvidences.pathFile.filter(element => element.split('/')[1] != args.file.name);
            }else{
                var obj = JSON.parse(args.e.srcElement.response);
                this.formDataEvidences.pathFile.push(obj.path);
            }
        },
        initComplianceEdit: function () {
            this.validIsAdmin = this.$store.getters['moduleAvatar/avatar'].admin;
            this.validStatus = this.data.status;
            this.formDataEvidences.statusComplianceId = this.data.est_id;
            this.formDataObservations.statusComplianceId = this.data.est_id;
            this.gridDataComplianceEvidences = this.data.compliance_status_evidence;
        },
        updateEvidences: function(){
            this.gridDataComplianceEvidences = []
            var for_i = this.processesDetail.statusCompliance;
            for (let i = 0; i < for_i.length; i++) {
                for (let j = 0; j < for_i[i].compliance_status_evidence.length; j++) {

                    if (for_i[i].compliance_status_evidence[j].estado_cumplimiento_id == this.data.est_id) {
                        this.gridDataComplianceEvidences = for_i[i].compliance_status_evidence;
                        break;
                    }
                }
            }
        },
        validateBeforeSubmitEvidences: function () {
            if (this.isSubmittingEvidences) {
                return;
            }

            let formStatus = this.formObjEvidences.validate();
            let hasExternalLink = (this.formDataEvidences.external_link || '').trim().length > 0;
            let hasFileUploaded = this.formDataEvidences.pathFile.length > 0;

            if (formStatus) {
                if (!hasExternalLink && !hasFileUploaded) {
                    return;
                }

                this.isSubmittingEvidences = true;
                axios.post('/auth/compliance/setComplianceEvidences', {
                    data: this.formDataEvidences,
                }).then(response => {
                    this.$store.dispatch('moduleProcesses/actionsProcessesDetail', this.data.proceso_id).then(response => {});
                    this.formObjEvidences.element.reset();
                    this.formDataEvidences.external_link = '';
                    this.formDataEvidences.pathFile = [];
                    Vue.prototype.$eventHub.$emit('showToastNotification', response.data);
                }).catch(() => {
                    // Permite reintento cuando la petición falla.
                }).finally(() => {
                    this.isSubmittingEvidences = false;
                });
            }
        },
        onChangeRadioStatus: function (args) {
            this.formData.status = args.event.target.ej2_instances[0].value;
        },
        onToggleFormsObservations: function () {

            this.toggleFormsObservations = !this.toggleFormsObservations;
        },
        onToggleFormsBasicData: function () {
            this.toggleFormsBasicData = !this.toggleFormsBasicData;
        },
        onToggleFormsEvidences: function () {
            this.toggleFormsEvidences = !this.toggleFormsEvidences;
        },
        changeEditFunction: function () {
            this.btnEditstatus = !this.btnEditstatus;
        },
        newRelevence: function (relevence) {
            this.formData.relevence = relevence;
        }
    },
    created: function () {
        this.initComplianceEdit();
    }
}
</script>
<style>
#editProcessButtonX {
    padding: 0px;
    color: #222222;
    cursor: pointer;
}

#editProcessButtonX::before {
    content: '\e944';
    font-family: 'e-icons';
    font-size: 13px;
}

.e-delete-1:before{
    cursor: pointer;
    content:'\e84e';
    color: red;
}

.e-hyperlink-open:before{
    cursor: pointer;
    content:'\e278';
}

.e-icons{
    font-size: 25px;
}
</style>
